export const formatPrice = (num) => {
  return '€' + num.toString().split( /(?=(?:\d{3})+(?:\.|$))/g ).join(',');
}